import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-taupe/60 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 grid gap-8 md:grid-cols-4">
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-full bg-forest text-linen flex items-center justify-center font-serif">S</span>
            <span className="font-serif text-lg text-forest">Sakeenah Circle</span>
          </div>
          <p className="text-sm text-forest/70 leading-relaxed">A peaceful, trusted circle of verified sitters — because your child deserves calm hands.</p>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.15em] uppercase text-forest/60 mb-3">For families</h4>
          <ul className="space-y-2 text-sm text-forest/80">
            <li><Link to="/browse">Find a sitter</Link></li>
            <li><Link to="/how-it-works">How it works</Link></li>
            <li><Link to="/register">Create account</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.15em] uppercase text-forest/60 mb-3">For sitters</h4>
          <ul className="space-y-2 text-sm text-forest/80">
            <li><Link to="/register?role=babysitter">Become a sitter</Link></li>
            <li><Link to="/how-it-works">Verification</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.15em] uppercase text-forest/60 mb-3">Contact</h4>
          <p className="text-sm text-forest/80">hello@sakeenahcircle.com</p>
        </div>
      </div>
      <div className="border-t border-taupe/60 py-5 text-center text-xs text-forest/60">
        © {new Date().getFullYear()} Sakeenah Circle. Care, curated with grace.
      </div>
    </footer>
  );
}
